import { render } from "./mainImgUpload.vue?vue&type=template&id=674910d0&scoped=true"
import script from "./mainImgUpload.vue?vue&type=script&lang=js"
export * from "./mainImgUpload.vue?vue&type=script&lang=js"

import "./mainImgUpload.vue?vue&type=style&index=0&id=674910d0&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674910d0"]])

export default __exports__